<template>
  <div class="scenario-images">
    <div class="images-wrapper">
      <Gallery :data="data" />
    </div>
  </div>
</template>

<script src="./ScenarioImages.js"></script>
